var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"closable":false,"title":"转出提示"},on:{"on-ok":_vm.ok},model:{value:(_vm.isShowModal),callback:function ($$v) {_vm.isShowModal=$$v},expression:"isShowModal"}},[_c('div',{staticStyle:{"margin":"25px"}},[_vm._v("此操作不可逆，是否继续操作？")])])
}
var staticRenderFns = []

export { render, staticRenderFns }